import React, {useState} from 'react'
import search from '../../img/search.svg';
import PropTypes from 'prop-types';
import {isMobile} from "react-device-detect";

const Search = (props) => {
  const {onSearch, defaultSearch, isShowSearch} = props;
  const [searchQuery, setSearchQuery] = useState(defaultSearch);
  const [activeInput, setActiveInput] = useState('');
  console.log(searchQuery, "searchQuery")

  /*const handleChange = (e) => {
    setSearchQuery(e.target.value)
    console.log(e.target.value, "handleChange", props)
  };*/

  const MouseEnter = () => {
    setActiveInput('activeInput')
  };
  const MouseLeave = () => {
    setActiveInput('')
  };

  return (
    <>
      {isShowSearch ?
        <div className='searchItem'
             onMouseEnter={
               () => {
                 MouseEnter()
               }
             }
             onMouseLeave={
               () => {
                 MouseLeave()
               }
             }
        >
          <>
          <input
            type='text'
            value={ searchQuery || ''}
            onChange={(e) => setSearchQuery(e.target.value)}
            className={`searchInput ${activeInput}`}
            placeholder={`${!isMobile ? 'Search' : ''}`}
          />
          </>
          <img className='search'
               src={search}
               alt='Search'
          />
        </div> : ''
      }
    </>
  )
};

export default Search

Search.propTypes = {
  value: PropTypes.string,
  onSearch: PropTypes.func.isRequired,
};
